export default {
  title: 'Planning face unitaire',
  racine: 'Accueil',
  actions: {
    filtre: 'Filtre',
  },
  tab: {
    reference: 'Réf',
    adresse: 'Adresse',
    ville: 'Ville',
    planning: 'Planning',
    rt: ' (RT)',
    societe: 'Société',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    reference: 'Référence',
    ville: 'Ville',
    format: 'Format',
    material: 'Matériel',
    avecReseaux: 'Afficher les affectations réseaux',
    eclaire: 'Eclairé',
    societe: 'Société',
    secteur: 'Secteur(s)',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
};
